export const standards = {
  Add_new_requirement: "Ajouter une nouvelle exigence",
  Add_requirement: "Ajouter une exigence",
  Add_section: "Ajouter une nouvelle section",
  Add_subsection: "Ajouter une sous-section",
  All_Clients: "Tous les clients",
  Content: "Contenu",
  Edit_requirement: "Modifier l'exigence",
  Expand_all: "Développer tout",
  Full_name: "Nom complet",
  Please_fill_in_the_requirement_information: "Veuillez remplir les informations de l'exigence",
  Published_date: "Date de publication",
  Read_less: "Lire moins",
  Read_more: "Lire plus",
  Reference: "Référence",
  Requirement_Info: "Informations sur l'exigence",
  Section_Reference: "Référence de section",
  Section_reference_is_required: "La référence de section est requise",
  Section_title: "Titre de section",
  Section_title_is_required: "Le titre de section est requis",
  Section_with_this_reference_already_exists: "Une section avec cette référence et ce titre existe déjà",
  Sections: "Sections",
  Standard_Body: "Organisme de normalisation",
  Standard_Guidance: "Orientation du standard",
  Standard_ID: "ID du standard",
  Sub_Section_with_this_title_already_exists: "Une sous-section avec cette référence et ce titre existe déjà",
  Sub_Sections: "Sous-sections",
  "Sub-Section_Reference": "Référence de sous-section",
  "Sub-Section_title": "Titre de sous-section",
  Tenants: "Locataires",
  This_cannot_be_deleted_until_all_the_associated_requirements_and_sub_sections_are_removed_first:
    "Ceci ne peut pas être supprimé tant que toutes les exigences associées et sous-sections ne sont pas supprimées en premier.",
  This_cannot_be_deleted_until_all_the_associated_requirements_are_removed_first:
    "Ceci ne peut pas être supprimé tant que toutes les exigences associées ne sont pas supprimées en premier.",
  Version: "Version",
  You_are_adding_a_new_requirement_to: "Vous ajoutez une nouvelle exigence à :",
} as const;
